import React, { useEffect, useState } from "react";
import { toAbsoluteUrl } from "../../_metronic/helpers";
import AddDashboardModal from "./AddDashboardModal";
import fetchTimeliveAPI from "../../common/fetchTimeliveAPI";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getValueFromResource } from "../../common/timeLiveFunction";
import { t } from "i18next";

interface Template {
  SystemDashboardTemplateId: number;
  SystemDashboardTemplateName: string;
  SystemDashboardTemplateDescription: string;
  SystemDashboardTemplateIconPath: string;
  IsFeatureEnabled: boolean;
  SystemFeatureId?: string | null;
}

const DashboardTemplates = () => {
  const { IsAdd } = useAppSelector((state) => state.dashboard);
  const [showModal, setShowModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(null);
  const [template, setTemplate] = useState<any[]>([]);
  const dispatch = useAppDispatch();

  const getDashboardTemplates = async () => {
    try {
      const response = await fetchTimeliveAPI("api/AccountDefaultDashboard/GetAccountDashboardTemaplets", "GET", "", true);
      const json = await response.json();
      setTemplate(json?.Data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getDashboardTemplates();
  }, [])

  const openModal = (item: Template) => {
    if (item.IsFeatureEnabled) {
      setSelectedTemplate(item);
      setShowModal(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedTemplate(null);
  };

  return (
    <>
      <div className="dashboard-wrapper">
        <div className="dashboard-container">

          <h2 className="dashboard-title">
            {/* Choose a Dashboard template */}
             {getValueFromResource("Choose a Dashboard template", dispatch, t)}
          </h2>

          <p className="dashboard-subtitle">
            {/* Get started with a Dashboard template or create a custom Dashboard to fit your exact needs. */}
             {getValueFromResource("Get started with a Dashboard template or create a custom Dashboard to fit your exact needs.", dispatch, t)}
          </p>

          <div className="dashboard-grid">
            {template.map((item, index) => (
              <div
                className="dashboard-card"
                key={index}
                onClick={() => {
                  if (!IsAdd) return;
                  openModal(item);
                }}
                style={{
                  cursor: item.IsFeatureEnabled ? "pointer" : "not-allowed",
                  opacity: item.IsFeatureEnabled ? 1 : 0.6,
                  filter: item.IsFeatureEnabled ? "none" : "grayscale(1)",
                  pointerEvents: item.IsFeatureEnabled ? "auto" : "all"
                }}
              >
                <div className="dashboard-card-content">

                  {item.SystemDashboardTemplateId === 7 ? (
                    <div className="add-icon">+</div>
                  ) : (
                    <img
                      src={toAbsoluteUrl(item.SystemDashboardTemplateIconPath)}
                      className="dashboard-icon"
                      alt=""
                    />
                  )}

                  <h4 className="dashboard-card-title">
                    {/* {item?.SystemDashboardTemplateName} */}
                    {getValueFromResource(`${item.SystemDashboardTemplateName}`, dispatch, t)}
                  </h4>

                  {item?.SystemDashboardTemplateDescription && (
                    <p className="dashboard-card-desc">
                      {/* {item?.SystemDashboardTemplateDescription} */}
                      {getValueFromResource(`${item.SystemDashboardTemplateDescription}`, dispatch, t)}
                    </p>
                  )}

                </div>
              </div>
            ))}
          </div>

        </div>
      </div>

      {showModal && <AddDashboardModal
        template={selectedTemplate}
        onClose={closeModal}
      />}
    </>
  );
};

export default DashboardTemplates;